export default __webpack_public_path__ + "3b6acf379b7d6ffba4d05c1c89740e96.woff2";